/** This form's `kind` in `CreateEntityWizardStore` — a `submitRequest`/`resetRequest` only triggers this component's handlers when its `tab` matches. */
export const ORGANIZATION_FORM_KIND = 'organization' as const;

/**
 * Shape of the Organization tab's Signal Form model. Plain strings/booleans on purpose — this widget has no Material/`WcgMenuOption`
 * dependency, so dropdowns stay native elements bound to raw codeset keys. `additionalType` is an array because "Additional
 * Organization Type" is a multiselect — a user can pick one or many secondary org types alongside the single `primaryType`.
 */
export interface OrganizationFormValue {
    name: string;
    primaryType: string;
    additionalType: string[];
    isIrbAffiliated: boolean;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
}

export const DEFAULT_ORGANIZATION_FORM_VALUE: OrganizationFormValue = {
    name: '',
    primaryType: '',
    additionalType: [],
    isIrbAffiliated: false,
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    country: ''
};
